import { SUBSCRIPTION_TYPE, BULK_SUBSCRIPTION_USER_ROLES } from "../constants/v2/Constants";

export default (subscription: Subscription): boolean => {
    if (subscription.type !== SUBSCRIPTION_TYPE.BULK) {
        return true;
    }

    if (subscription.bulkSubscriptionMetadata?.role === BULK_SUBSCRIPTION_USER_ROLES.ADMIN) {
        return true;
    }

    return false;
};
